import type { WishlistButtonV1Attributes } from '@/features/wishlist/wishlist-button-v1/wishlist-button-v1-type';

import React from 'react';

import { WishlistButton } from '@/core/features';

export default function WishlistButtonV1Desktop({ id, isSelected }: WishlistButtonV1Attributes) {
    return (
        <div className={'margin-10'}>
            <WishlistButton
                isInitiallySelected={isSelected}
                type={'transparent'}
                wishlistId={id}
            />
        </div>
    );
}
